<div>
    {{copyrightNotice}}
</div>
